export const OPEN_PANEL = 'OPEN_PANEL'
export const openPanel = payload => ({
    type: OPEN_PANEL,
    payload,
})

export const OPEN_PANEL_WITH_DATA = 'OPEN_PANEL_WITH_DATA'
export const openPanelWithData = payload => ({
    type: OPEN_PANEL_WITH_DATA,
    payload,
})

export const OPEN_EXERCISE_PANEL = 'OPEN_EXERCISE_PANEL'
export const openExercisePanel = payload => ({
    type: OPEN_EXERCISE_PANEL,
    payload,
})

export const OPEN_FEEDBACK_PANEL = 'OPEN_FEEDBACK_PANEL'
export const openFeedbackPanel = payload => ({
    type: OPEN_FEEDBACK_PANEL,
    payload,
})

export const CLOSE_PANEL = 'CLOSE_PANEL'
export const closePanel = panel => ({
    type: CLOSE_PANEL,
    payload: panel,
})

export const CLOSE_LAST_PANEL = 'CLOSE_LAST_PANEL'
export const closeLastPanel = () => ({
    type: CLOSE_LAST_PANEL,
})

export const SET_CURRENT_SIDEBAR_WIDTH = 'SET_CURRENT_SIDEBAR_WIDTH'
export const setCurrentSideBarWidth = (width) => {
    return {
        type: SET_CURRENT_SIDEBAR_WIDTH,
        payload: { width },
}}
